import {Component, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {APIKeyType as RTQ, APIStatus as APISTT} from '../../shared/common-components/AppConstants';
import {AgencyTokenAPIService} from '../../services/agency-token-api/agency-token-api.service';
import {AgencyTokenObj} from './AgencyTokenObj';
import {formatDate} from '@angular/common';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import { TspAgyProfileAuditTrailComponent } from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
@Component({
    selector: 'app-agency-token-api',
    templateUrl: './agency-token-api.component.html',
    styleUrls: ['./agency-token-api.component.css'],
    standalone: false
})

export class AgencyTokenAPIComponent implements OnInit {
  defaultDate = null;
  rateQueryTypes: String[] = [RTQ.RateQueryFRT, RTQ.RateQueryHHG];
  apiStatus: String[] = [APISTT.Active, APISTT.Inactive, APISTT.Deleted];
  generateAPIFormGroup: UntypedFormGroup;
  agencyTokenObj: AgencyTokenObj;

  apiSelectedType: string = null;
  apiSelectedStatus: string = null;
  submitted = false;
  organizationId: any = null;
  isOldOrganizationAPI = false;
  paramToAgencyProfile: any;
  nameRegex: RegExp = /^[a-zA-Z0–9 _]*$/;
  currentDate: Date = new Date();

  format = 'MM/dd/yyyy';
  locale = 'en-US';
  auditTrailLogList: any;
  profileName: any = "Organization API Audit Trail";
  private tmssLoader;
  bsModalRef: BsModalRef;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              private router: Router,
              private agencyTokenAPIService: AgencyTokenAPIService,
              private shipmentAuditTrailService: ShipmentAuditTrailService,
              private modalService: BsModalService
  ) {
    this.tmssLoader = this.loader;
    this.buildAPIForm();
  }

  ngOnInit() {
    this.agencyTokenObj = new AgencyTokenObj();
    this.buildAPIForm();
    this.tmssLoader.show();
    this.route.queryParams.subscribe(params => {
        this.paramToAgencyProfile = params;
        if (params['orgId']) {
          this.organizationId = Number(params['orgId']);
          this.loadOrganizationApibyOragnizationId();
          this.tmssLoader.hide();
        } else {
          this.organizationId = null;
          this.tmssLoader.hide();
          this.alertService.error('There was an error retrieving Organization');
        }
      }, error => {
        console.log('ERROR while getting token based on organization');
      }
    );

  }

  loadOrganizationApibyOragnizationId() {
    this.agencyTokenAPIService.getOrganization(this.organizationId).subscribe(organizationEntity => {
      // load data to form
      this.isOldOrganizationAPI = true;
      this.mapDataToObject(organizationEntity);
      this.loadDataToForm();
    }, error => {
      this.isOldOrganizationAPI = false;
      // present empty form
      this.loadDataToForm();
    });
  }

  // has data -> map to object
  mapDataToObject(tempOrganizationEntity: any) {
    this.agencyTokenObj.organizationApiId = tempOrganizationEntity.organizationApiId;
    this.agencyTokenObj.organizationId = tempOrganizationEntity.organizationId;
    this.agencyTokenObj.agencyToken = tempOrganizationEntity.agencyToken;
    this.agencyTokenObj.apiKeyType = tempOrganizationEntity.apiKeyType;
    this.agencyTokenObj.apiKeyStatus = tempOrganizationEntity.apiKeyStatus;
    this.agencyTokenObj.effectiveDate = tempOrganizationEntity.effectiveDate;
    this.agencyTokenObj.expiryDate = tempOrganizationEntity.expiryDate;
    this.agencyTokenObj.updateProgram = tempOrganizationEntity.updateProgram;
    this.agencyTokenObj.updateId = tempOrganizationEntity.updateId;
    this.agencyTokenObj.updateDate = tempOrganizationEntity.updateDate;
    this.agencyTokenObj.reqFirstName = tempOrganizationEntity.reqFirstName;
    this.agencyTokenObj.reqMiddleName = tempOrganizationEntity.reqMiddleName;
    this.agencyTokenObj.reqLastName = tempOrganizationEntity.reqLastName;
    this.agencyTokenObj.reqEmail = tempOrganizationEntity.reqEmail;
  }

  // has data -> load to UI ; No data => load empty form or keep it from build APIForm
  loadDataToForm() {
    if (this.agencyTokenObj) {
      this.generateAPIFormGroup.setValue({
        apiType: this.agencyTokenObj.apiKeyType,
        apiStatus: this.agencyTokenObj.apiKeyStatus,
        effectiveDate: (this.agencyTokenObj?.effectiveDate) ? (new Date(formatDate(this.agencyTokenObj.effectiveDate, this.format, this.locale))) : (new Date(formatDate(this.currentDate, this.format, this.locale))),
        expiryDate: (this.agencyTokenObj?.expiryDate) ? (new Date(formatDate(this.agencyTokenObj.expiryDate, this.format, this.locale))) : (new Date(formatDate(this.currentDate, this.format, this.locale))),
        agencyToken: (this.agencyTokenObj.agencyToken) ? (this.agencyTokenObj.agencyToken) : null,
        reqFirstName: (this.agencyTokenObj.reqFirstName) ? (this.agencyTokenObj.reqFirstName) : null,
        reqMiddleName: (this.agencyTokenObj.reqMiddleName) ? (this.agencyTokenObj.reqMiddleName) : null,
        reqLastName: (this.agencyTokenObj.reqLastName) ? (this.agencyTokenObj.reqLastName) : null,
        reqEmail: (this.agencyTokenObj.reqEmail) ? (this.agencyTokenObj.reqEmail) : null
      });
    }
  }

  buildAPIForm(): void {
    this.generateAPIFormGroup = this.fb.group({
      apiType: new UntypedFormControl('', Validators.required),
      apiStatus: new UntypedFormControl('', Validators.required),
      effectiveDate: new UntypedFormControl(new Date(), Validators.required),
      expiryDate: new UntypedFormControl(new Date(), Validators.required),
      agencyToken: new UntypedFormControl('', Validators.required),
      reqFirstName: new UntypedFormControl(null, [Validators.required, Validators.pattern(this.nameRegex)]),
      reqMiddleName: new UntypedFormControl(null, [Validators.pattern(this.nameRegex)]),
      reqLastName: new UntypedFormControl(null, [Validators.required, Validators.pattern(this.nameRegex)]),
      reqEmail: new UntypedFormControl(null, [Validators.required, Validators.email]),
    }, {validator: this.checkDates});
  }

  checkDates(group: UntypedFormGroup) {
    if (group.controls.effectiveDate.value > group.controls.expiryDate.value) {
      return {notValid: true};
    }
    return null;
  }

  generateAPI() {
    this.agencyTokenAPIService.getgeneratedToken(this.organizationId).subscribe(data => {
      this.agencyTokenObj.agencyToken = data[0];
      this.generateAPIFormGroup.get('agencyToken').setValue(data[1]);
    }, error => {
      console.log('ERROR! CANNOT GENERATE A TOKEN');
    });
    this.generateAPIFormGroup.get('agencyToken').setValue(Math.floor(Math.random()));
  }

  buildData(): void {
    this.agencyTokenObj.apiKeyStatus = this.getAValueFormControl('apiStatus');
    this.agencyTokenObj.agencyToken = this.getAValueFormControl('agencyToken');
    this.agencyTokenObj.apiKeyType = this.getAValueFormControl('apiType');
    this.agencyTokenObj.effectiveDate = this.getAValueFormControl('effectiveDate');
    this.agencyTokenObj.expiryDate = this.getAValueFormControl('expiryDate');
    this.agencyTokenObj.reqFirstName = this.getAValueFormControl('reqFirstName');
    this.agencyTokenObj.reqMiddleName = this.getAValueFormControl('reqMiddleName');
    this.agencyTokenObj.reqLastName = this.getAValueFormControl('reqLastName');
    this.agencyTokenObj.reqEmail = this.getAValueFormControl('reqEmail');
    if (this.isOldOrganizationAPI === false) {
      this.agencyTokenObj.organizationId = this.organizationId;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.generateAPIFormGroup.valid) {
      this.buildData();
      this.tmssLoader.show();
      this.agencyTokenAPIService.saveOragnizationApi(this.agencyTokenObj).subscribe((data) => {
        this.tmssLoader.hide();
        if (this.isOldOrganizationAPI) {
          this.alertService.success('Successfully Save Token');
        } else {
          this.alertService.success('Successfully Create Token');
        }
      }, (error) => {
        console.log('ERROR! CANNOT CREATE/SAVE TOKEN');
        // this.alertService.error(error);
      });
    } else {
      console.log('ERROR! FORM IS NOT VALID');
    }
  }

  isFieldValid(field: string) {
    return this.generateAPIFormGroup.get(field)?.errors;
  }

  getAValueFormControl(field: string) {
    return this.generateAPIFormGroup.get(field).value;
  }

  gotToAgencyProfile() {
    this.router.navigate(['/agencyprofile'], {
      queryParams: this.paramToAgencyProfile
    });
  }

 viewAuditTrial() {
     this.tmssLoader.show();
    //  this.profileName = this.carrierAgencyDetails; getAuditTrailListByOrgIdAndUpdateProgram(orgId: number, updateProgram: string): Observable<any> {
     this.shipmentAuditTrailService.getAuditTrailListByOrgIdAndUpdateProgram(this.organizationId, "Organization-API").subscribe(data => {
                 //      console.log('auditTrailLogList data: ' + data);
       if (data) {
 
           this.auditTrailLogList = data;
           console.log('Successfully retrieved audit records And auditTrailLogList length: ' + this.auditTrailLogList.length);
           const initialState: any = {
           auditTrailLogList: this.auditTrailLogList,
           profile: this.profileName
           };
           this.bsModalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });
 
       } else {
         this.alertService.error('No Audit Trail to display.');
       }
       this.tmssLoader.hide();
     }, (error) => {
       console.log('There was an error retrieving auditTrailLog records');
       this.tmssLoader.hide();
       this.alertService.error('There was an error retrieving auditTrailLog records');
     });
 
   }
}
